<template>
  <div class="order-page">
    <div class="container">
      <div :class="{up:!showSearch}" class="opera-btn-group">
        <div class="opera-icon">
          <span class="pull-right opera-btn" style="margin-left: 10px">
            <perm label="traceCode-data-cancel-add">
              <span @click.stop="add">
                   <a href="#" class="btn-circle" @click.prevent="" style="margin-right: 5px"><i
                       class="el-icon-t-plus"></i> </a>添加
              </span>
            </perm>
          </span>
          <span class="pull-left switching-icon" @click="showSearch = !showSearch">
              <i class="el-icon-arrow-up"></i>
              <span v-show="showSearch">收起筛选</span>
              <span v-show="!showSearch">展开筛选</span>
            </span>
        </div>
        <el-form v-show="showSearch" class="advanced-query-form" onsubmit="return false">
          <el-row>
            <el-col :span="12">
              <oms-form-row label="创建时间范围" :span="8">
                <el-date-picker
                    :default-time="['00:00:00', '23:59:59']"
                    v-model="searchCondition.time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="状态" :span="6">
                <el-select v-model="searchCondition.state" placeholder="请选择">
                  <el-option
                      v-for="item in stateOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row :span="5" label="">
                <el-button @click="searchInOrder" plain type="primary">查询</el-button>
                <el-button @click="resetSearchForm" native-type="reset">重置</el-button>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="8">操作单位</el-col>
          <el-col :span="5">创建时间</el-col>
          <el-col :span="5">操作人</el-col>
          <el-col :span="3">状态</el-col>
          <el-col :span="3">操作</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="!orderList.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div class="order-list-body flex-list-dom" v-else="">
          <div :class="[{'active':currentId===item.codeCancellationTaskId}]" @click.prevent="showItem(item)"
               class="order-list-item order-list-item-bg"
               v-for="item in orderList">
            <el-row>
              <el-col :span="8">
                {{ item.orgName }}
              </el-col>
              <el-col :span="5">
                {{ item.createTime | time }}
              </el-col>
              <el-col :span="5">
                {{ item.creatorName }}
              </el-col>
              <el-col :span="3">
                {{ stateOptions.find(f => f.value === item.codeCancellationTaskStatus).label }}
              </el-col>
              <el-col :span="3">
                <des-btn style="margin-right: 8px" class="is-mini" perm="traceCode-data-cancel-view" icon="t-search"
                         @click="showItem(item)">查看
                </des-btn>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-show="pager.count>pager.pageSize && !loadingData">
      <el-pagination
          :current-page="pager.currentPage"
          :pageSize="pager.pageSize" :total="pager.count" @current-change="getOrderList"
          layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <page-right :css="{'width':'800px','padding':0}" :show="showItemRight" @right-close="resetApply">
      <applyInform :action="action" :defaultIndex="defaultIndex" @change="onSubmit" @close="resetApply"
                   @refresh="refresh" ref="applyInForm"
                   type="0"></applyInform>
    </page-right>
    <page-right :css="{'width':'600px','padding':0}" :show="showDomain" @right-close="resetRightBox">
      <share-form :currentItem="currentItem" :showDetail="showDomain" @change="onSubmit"
                  @close="resetRightBox"></share-form>
    </page-right>
    <page-right :show="applyViewVisible" @right-close="applyViewClose">
      <GoodsCheck :tabledatas="checkTableData" :platform="false" :form="currentItem"></GoodsCheck>
    </page-right>
  </div>
</template>
<script>
import utils from '@/tools/utils';
import addForm from './form/InForm.vue';
import detail from './detail/detail.vue';
import {http, Order, traceCode} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';
import ShareForm from './form/shareForm';
import applyInform from './form/cancelForm';
import GoodsCheck from './form/cancelView';

export default {
  components: {
    addForm, detail, ShareForm, applyInform, GoodsCheck
  },
  mixins: [methodsMixin],
  data: function () {
    return {
      applyViewItem: null,
      applyViewVisible: false,

      checkTableData: [],

      stateOptions: [
        {
          value: '0',
          label: '处理中'
        }, {
          value: '1',
          label: '已完成'
        }
      ],
      loadingData: false,
      showItemRight: false,
      showDetail: false,
      showSearch: true,
      showDomain: false,
      orderList: [],
      filters: {
        type: 0,
        objectOrgId: '',
        goodsId: '',
        batchNumber: '',
        factoryId: '',
        bizType: '',
        time: '',
        state: ''
      },
      searchCondition: {
        objectOrgId: '',
        goodsId: '',
        batchNumber: '',
        factoryId: '',
        bizType: '',
        time: null,
        state: ''
      },
      expectedTime: [],
      orgType: utils.inOrderType,
      activeStatus: 0,
      currentId: '',
      currentItem: {},
      customerList: [], // 查询 疾控中心列表
      orgList: [], // 来源单位列表
      logisticsList: [], // 物流商列表
      pager: {
        currentPage: 1,
        count: 0,
        pageSize: 20
      },
      defaultIndex: 0, // 添加订单默认选中第一个tab
      action: '',
      user: {},
      uploadStatusList: utils.uploadStatus,
      urlTitle: {
        0: 'system',
        1: 'retrospect',
        2: 'system/all'
      }
    };
  },
  computed: {
    type() {
      return this.$route.meta.type;
    },
    isUploadPage() {
      return this.type === 1;
    }
  },
  mounted() {
    let id = this.$route.params.id;
    if (id && id !== 'id') {
      let params = {
        codeCancellationTaskId: id
      }
      traceCode.getCancelList(params).then(res => {
        this.showItem(res.data.list[0])
      })
    }
    this.getOrderList(1);
  },
  watch: {
    type() {
      this.getOrderList(1);
    }
  },
  methods: {
    applyViewClose() {
      this.applyViewVisible = false;
      this.checkTableData = [];
      this.$router.push(`/retrospect/goods/cancel/id`);
    },
    codeDownload(item) {
      traceCode.download(item.codeApplyTaskId).then(res => {
        let url = res.data[0].attachmentStoragePath;
        window.open(url);
      }).catch(e => {
        this.$notify.error({
          duration: 2000,
          message: e.response && e.response.data && e.response.data.msg || '解析失败'
        });
      })
    },
    codeComplete(item) {
      traceCode.downloadComplete(item.codeApplyTaskId).then(res => {
        item.taskStatus = '2';
      }).catch(e => {
        this.$notify.error({
          duration: 2000,
          message: e.response && e.response.data && e.response.data.msg || '解析失败'
        });
      })
    },
    searchInOrder: function () {// 搜索
      this.getOrderList(1);
    },
    resetSearchForm: function () {// 重置表单
      this.pager.count = 0;
      this.orderList = [];
      let temp = {
        objectOrgId: '',
        goodsId: '',
        batchNumber: '',
        bizType: '',
        factoryId: '',
        time: '',
        state: ''
      };
      this.expectedTime = [];
      this.goodsBatchNumberList = [];
      Object.assign(this.searchCondition, temp);
      Object.assign(this.filters, temp);
      this.searchInOrder();
    },
    resetApply() {
      this.showDetail = false;
      this.showItemRight = false;
      this.showDomain = false;
      this.defaultIndex = 0;
      this.action = '';
      this.$refs.applyInForm.tabledatas = [];
      this.$refs.applyInForm.resetTable();
    },
    resetRightBox: function () {
      this.showDetail = false;
      this.showItemRight = false;
      this.showDomain = false;
      this.defaultIndex = 0;
      this.action = '';
      this.$router.push(`/retrospect/goods/apply/id`);
    },
    add: function () {
      this.showItemRight = true;
      this.defaultIndex = 1;
      this.action = 'add';
    },
    refresh(obj) {
      this.resetRightBox();
      if (obj && obj.id) {
        this.showItem(obj);
      }
      this.getOrderList(1);
    },
    onSubmit: function (order) {
      this.orderList.splice(0, 0, order);
      this.currentId = order.codeApplyTaskId;
      this.currentItem = order;
    },
    getOrderList: function (pageNo) {
      if (pageNo) {
        this.pager.currentPage = pageNo;
      }
      let param = {};
      this.loadingData = true;
      let params = {
        createEndTime: this.searchCondition.time ? this.searchCondition.time[1] : '',
        createStartTime: this.searchCondition.time ? this.searchCondition.time[0] : '',
        createdOrgId: this.$store.state.user.userCompanyAddress,
        codeCancellationTaskStatus: this.searchCondition.state,
      }
      traceCode.getCancelList(params, pageNo, this.pager.pageSize).then(res => {
        this.orderList = res.data.list;
        this.pager.count = res.data.count;
        this.loadingData = false;
      })
    },
    remove: function (order) {
      Order.delete(order.id).then(() => {
        this.getOrderList(1);
      });
    },
    queryTaskCode(order) {
      let params = {
        codeApplyTaskId: order.codeApplyTaskId
      }
      // traceCode.queryList(params).then(res => {
      //   console.log(res);
      // })
      // traceCode.queryList(params).then(res => {
      //   order.taskStatus = res.data.list[0].taskStatus;
      // })
      traceCode.getInfo(order.codeApplyTaskId).then(res => {
        // console.log(res);
        order.codeCancellationTaskStatus = res.data.codeCancellationTaskStatus;
        this.checkTableData = res.data.detailDtoList;
      });
      this.applyViewVisible = true;
    },
    showItem: function (order) {
      // console.log(order);
      this.currentId = order.codeCancellationTaskId;
      this.currentItem = null;
      // traceCode.queryList(params).then(res => {
      //   console.log(res);
      // })
      // traceCode.queryList(params).then(res => {
      //   order.taskStatus = res.data.list[0].taskStatus;
      // })
      traceCode.getCancelInfo(order.codeCancellationTaskId).then(res => {
        // console.log(res);
        this.currentItem = res.data;
        order.codeCancellationTaskStatus = res.data.codeCancellationTaskStatus;
      });
      this.applyViewVisible = true;
      this.$router.push(`/retrospect/goods/cancel/` + order.codeCancellationTaskId);
    },
    showDomainDialog: function (order) {
      this.currentItem = order;
      this.showDomain = true;
    },
    goodsChange(val) {

      this.searchCondition.batchNumber = '';
      this.goodsBatchNumberList = [];
      if (!val) return;
      this.platformGoods.forEach(i => {
        if (i.id === val) {
          this.searchCondition.objectOrgId = i.factoryId;
          this.downOrgList = [
            {
              id: i.factoryId,
              name: i.factoryName
            }
          ];
          this.queryPermDownAllFactory(i.factoryName);
        }
      });
      this.queryGoodsNumber('searchCondition.goodsId')('');
    }
  }
};
</script>
